import React from "react";
import { RoomAction, RoomActionType } from "../../../entities/room-history.entity";
import { displayDate } from "src/utils/dateHandler.util";
import { User } from "src/features/users/types/user.entity";
import {
  FiLogIn,
  FiLogOut,
  FiMic,
  FiMicOff,
  FiGift,
  FiUserX,
  FiUserCheck,
  FiChevronUp,
  FiChevronDown,
  FiCheck,
  FiX,
} from "react-icons/fi";

type HistorySectionProps = {
  history: RoomAction[];
  usersMap: Record<string, User>;
};

const actionConfig: Record<
  RoomActionType,
  { icon: React.ReactNode; label: string; color: string }
> = {
  JOINED: {
    icon: <FiLogIn className="w-4 h-4" />,
    label: "Joined",
    color: "bg-green-100 text-green-700",
  },
  LEFT: {
    icon: <FiLogOut className="w-4 h-4" />,
    label: "Left",
    color: "bg-gray-100 text-gray-700",
  },
  STAGING_REQUESTED: {
    icon: <FiChevronUp className="w-4 h-4" />,
    label: "Requested Stage",
    color: "bg-yellow-100 text-yellow-700",
  },
  ON_STAGE: {
    icon: <FiMic className="w-4 h-4" />,
    label: "On Stage",
    color: "bg-blue-100 text-blue-700",
  },
  DOWN_FROM_STAGE: {
    icon: <FiChevronDown className="w-4 h-4" />,
    label: "Left Stage",
    color: "bg-gray-100 text-gray-700",
  },
  MUTED: {
    icon: <FiMicOff className="w-4 h-4" />,
    label: "Muted",
    color: "bg-orange-100 text-orange-700",
  },
  INVITED_ON_STAGE: {
    icon: <FiUserCheck className="w-4 h-4" />,
    label: "Invited to Stage",
    color: "bg-indigo-100 text-indigo-700",
  },
  STAGE_REQUEST_ACCEPTED: {
    icon: <FiCheck className="w-4 h-4" />,
    label: "Request Accepted",
    color: "bg-green-100 text-green-700",
  },
  STAGE_REQUEST_REJECTED: {
    icon: <FiX className="w-4 h-4" />,
    label: "Request Rejected",
    color: "bg-red-100 text-red-700",
  },
  GIFT: {
    icon: <FiGift className="w-4 h-4" />,
    label: "Gift",
    color: "bg-purple-100 text-purple-700",
  },
  KICKED_OUT: {
    icon: <FiUserX className="w-4 h-4" />,
    label: "Kicked Out",
    color: "bg-red-100 text-red-700",
  },
};

export const HistorySection: React.FC<HistorySectionProps> = ({ history, usersMap }) => {
  console.log("history", history);
  return (
    <div className="relative">
      {/* Timeline line */}
      <div className="absolute left-6 top-0 bottom-0 w-0.5 bg-gray-200"></div>

      <div className="space-y-4">
        {history.map((action, index) => {
          const config = actionConfig[action.action];
          console.log("config", config);
          
          const user = usersMap[action.userId];
          const userName = user?.name || action.userId;
          const receiver = action.metadata?.receiverId ? usersMap[action.metadata.receiverId] : null;
          const receiverName = receiver?.name || action.metadata?.receiverId;
          
          return (
            <div key={action.id} className="relative flex items-start gap-4 pl-12">
              {/* Timeline dot */}
              <div
                className={`absolute left-4 w-5 h-5 rounded-full flex items-center justify-center ${config.color} ring-4 ring-white`}
              >
                {config.icon}
              </div>

              {/* Content */}
              <div className="flex-1 bg-gray-50 rounded-xl p-4 hover:bg-gray-100 transition-colors">
                <div className="flex items-center justify-between mb-1">
                  <span
                    className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium ${config.color}`}
                  >
                    {config.label}
                  </span>
                  <span className="text-xs text-gray-500">
                    {displayDate(action.timestamp)}
                  </span>
                </div>
                <p className="text-sm text-gray-700">
                  User: <span className="font-medium">{userName}</span>
                </p>
                {action.metadata?.receiverId && (
                  <p className="text-sm text-gray-600 mt-1">
                    Receiver: <span className="font-medium">{receiverName}</span>
                  </p>
                )}
                {action.metadata?.amount !== undefined && (
                  <p className="text-sm text-purple-600 font-medium mt-1">
                    Amount: {action.metadata.amount}
                  </p>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
